import React from 'react';

import { BottomCard } from '../BottomCard';
import styles from './BottomCardNavigation.styles';

const BottomCardNavigation = ({ data, btnText, arrow, arrowHover, urlFirst, urlSecond }) => {
  const { cardFirst, cardSecond } = data;
  return (
    <div css={styles}>
      <div className="bottomCard-container">
        <BottomCard data={cardFirst} btnText={btnText} arrow={arrow} arrowHover={arrowHover} url={urlFirst} />
        <BottomCard data={cardSecond} btnText={btnText} arrow={arrow} arrowHover={arrowHover} url={urlSecond} />
      </div>
    </div>
  );
};

export default BottomCardNavigation;
